import { combineReducers } from "redux";
import infra from "#/infra/redux/reducer";
import dashboard from "#/modules/dashboard/redux/reducer";
import applicationsReducer from "../../modules/applications/slice";
import policiesReducer from "../../modules/policies/slice";

const rootReducer = combineReducers({
  infra,
  dashboard,
  applications: applicationsReducer,
  policies: policiesReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
